export const actionTypes = {
  FETCH_USER_ENTITLEMENT_REQUEST: "FETCH_USER_ENTITLEMENT_REQUEST",
  FETCH_USER_ENTITLEMENT_REQUEST_SUCCESS:
    "FETCH_USER_ENTITLEMENT_REQUEST_SUCCESS",
  FETCH_USER_ENTITLEMENT_REQUEST_FAILURE:
    "FETCH_USER_ENTITLEMENT_REQUEST_FAILURE",
};

export const fetchUserEntitlementRequestAction = (payload: any) => {
  return {
    type: actionTypes.FETCH_USER_ENTITLEMENT_REQUEST,
    payload,
  };
};

export const fetchUserEntitlementRequesSuccesstAction = (payload: any) => {
  return {
    type: actionTypes.FETCH_USER_ENTITLEMENT_REQUEST_SUCCESS,
    payload,
  };
};

export const fetchUserEntitlementRequestFailureAction = (error: any) => {
  return {
    type: actionTypes.FETCH_USER_ENTITLEMENT_REQUEST_FAILURE,
    error,
  };
};
